/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-did-update-set-state */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Card, CardTitle, Col, Row } from 'reactstrap';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import {} from 'mapbox-gl-leaflet';
import 'leaflet.gridlayer.googlemutant/dist/Leaflet.GoogleMutant';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import drawLocales from 'leaflet-draw-locales';
import { HOC as Permissions } from 'react-redux-permissions';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import Forbidden from '../../../Forbidden';
import styles from './map.module.scss';
import cardstyles from '../forms/forms.module.scss';
import Clickable from '../../../../components/clickable/Clickable';

let map = {};
const drawnItems = {};
const language = localStorage.getItem('lang') || 'en';
drawLocales(language !== 'az' ? language : 'en');

class Map extends Component {
  constructor(props) {
    super(props);
    this.addPopupToLayer = this.addPopupToLayer.bind(this);
  }

  async componentDidMount() {
    const { location } = this.props;
    if (location?.length > 0) {
      setTimeout(() => {
        this.initializeMap();
        this.mapSurfaces();
      }, 3000);
    }
  }

 mapSurfaces = () => {
  const { map_surfaces } =this.props;
  map.invalidateSize();
    map_surfaces.forEach(({ id }) => {
      drawnItems[id] = new L.FeatureGroup();
      map.addLayer(drawnItems[id]);
      return true;
    });
     map_surfaces.forEach((o) => {
      if (o?.link_acr === true && o.polygon) {
        let l = L.geoJSON(o.polygon)._layers;
        [l] = Object.keys(l).map(ob => l[ob]);
        const customlayer = this.addPopupToLayer(o.asset_type.color, l);
        map.addLayer(drawnItems[o.id].addLayer(customlayer));
      }
      if (Object.keys(o?.acr_label_info).length>0) {
        // eslint-disable-next-line new-cap
        const markerLayer = new L.marker({ lon: o?.acr_label_info?.coordinates[0], lat: o?.acr_label_info?.coordinates[1] }, {
          draggable: false,
          icon: new L.DivIcon({
            className: `${styles.myDivIcon}`,
            html: `<div class="${styles.myDivSpan}" 
              style='background:#3a61a8; width: max-content;padding:1px 11px 1px 11px'><b>${o.remarks}</b></div>`
              })
        });
        map.addLayer(drawnItems[o.id].addLayer(markerLayer));
      }
    });
 }


  addPopupToLayer = (color, layer) => {
    const customlayer = layer;
    customlayer.setStyle({
      fillColor: color,
      color,
      opacity: 1,
      fillOpacity: 0.28
    });
    return customlayer;
  };

  // eslint-disable-next-line react/sort-comp
  initializeMap() {
    const { mapStyle, location } = this.props;
    const defaultLocation = location;
    const curLocation = [defaultLocation[1], defaultLocation[0]];
    map = L.map('map', {
      center: curLocation,
      zoom: 15,
      fullscreenControl: true,
      attributionControl: false
    });
    if (mapStyle?.mapbox_style) {
      L.mapboxGL({
        accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
        style: mapStyle?.mapbox_style
      }).addTo(map);
    } else {
      L.gridLayer.googleMutant({ type: 'satellite', maxZoom: 20 }).addTo(map);
    }
  }

  render() {
    const { enableMap, handelFullScreen, fullScreenMode } = this.props;

    return (
      <Fragment>
        <Col lg={12} className={cardstyles.cardHeight}>
        { enableMap
        && <Card className={cardstyles.formCard} style={{ height: fullScreenMode?'100vh': '100%', width: fullScreenMode?'100vw': '100%' }}>
          <div className="drag-handle">
            <CardTitle className={cardstyles.airfieldscardtitle}>
              <Col lg={12}>
                <Row className={cardstyles.notamsHead}>
                  <Col className={cardstyles.notamText}>
                    <FormattedMessage
                      id="wildlife.dashboard.map"
                      defaultText="Maps"
                    />
                  </Col>
                  <Col lg={3}>
                          {!fullScreenMode && (
                            <Clickable onClick={() => { handelFullScreen(true, 7); }}>
                              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end' }}>
                                <FullscreenIcon />
                              </p>
                            </Clickable>
                          )}
                          {fullScreenMode && (
                            <Clickable onClick={() => { handelFullScreen(false, 7); }}>
                              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end' }}>
                                X
                              </p>
                            </Clickable>
                          )}
                  </Col>
                </Row>
              </Col>
            </CardTitle>
          </div>
            <hr className={cardstyles.hrLine} />
                <div id="map" className={styles.map} />
           </Card>
  }
        </Col>
      </Fragment>
    );
  }
}

export default Permissions([])(
  connect()(Map),
  <Forbidden />
);
